
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import { formatDinero } from "../../../utils/formatDinero"
import { EstatusCompra } from "../../../constant/catEstatusCompra"
import FItemExtra from "../FItemExtra"
import FEnviarExtra from "../FEnviarExtra"
import EstatusCompraExtra from "../Estatus"
import { obtenerExtrasContratadosPaginaAction, obtenerExtrasContratadosRegistrosAction } from "../../../ducks/ExtrasContratadosDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
const columns = [
    { id: "1", minWidth: 50, align: "center", label: "Referencia" },
    { id: "2", minWidth: 50, align: "center", label: "Nombre" },
    { id: "3", minWidth: 50, align: "center", label: "Paquete" },
    { id: "4", minWidth: 50, align: "center", label: "Clave viaje" },
    { id: "5", minWidth: 50, align: "center", label: "No. Pax." },
    { id: "6", minWidth: 50, align: "center", label: "Fecha salida" },
    { id: "7", minWidth: 50, align: "center", label: "Nombre extra" },
    { id: "8", minWidth: 50, align: "center", label: "Total" },
    { id: "9", minWidth: 50, align: "center", label: "Estatus" },
    { id: "10", minWidth: 50, align: "center", label: "" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TExtrasContratados = () => {
    const { listExtrasContratados, total, pagina, registros } = useSelector(store => store.extrasContratados)
    const rows = listExtrasContratados ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerExtrasContratadosPaginaAction({ pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerExtrasContratadosRegistrosAction({ registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.IdExtraPaqueteProveedor}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row?.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.NomCliente}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.NomPaquete}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.ClaveViaje}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row?.CanPasajero}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${FormatoFechaIso({ date: row?.FecSalida, formato: 'dd-MM-yyyy' })}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.NomExtra}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${formatDinero(row?.MonExtra * row?.CanPasajero)}`}
                                        </TableCell>
                                        <TableCell>
                                            <EstatusCompraExtra estatus={row?.Compra?.estatusCompra?.idEstatusCompra} />
                                        </TableCell>
                                        <TableCell align="center">
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                                                {
                                                    (row?.Compra?.estatusCompra?.idEstatusCompra === EstatusCompra.NoAplica) &&
                                                    <FItemExtra
                                                        idMoneda={row?.Meta?.Paquete?.MonedaProveedor?.id_moneda}
                                                        idCuenta={row?.Meta?.Cuenta?.Id_Cuenta}
                                                        idPaquete={row?.Meta?.Paquete?.Id_Paquete}
                                                        Referencia={row?.Meta?.Referencia}
                                                        idExtra={row?.IdExtra}
                                                        disabled={(row?.Compra?.estatusCompra?.idEstatusCompra !== EstatusCompra.NoAplica) ? true : false}
                                                    />
                                                }
                                                {
                                                    (row?.Compra?.estatusCompra) ? row?.Compra?.estatusCompra?.DscEstatus : ""
                                                }
                                                {
                                                    (row?.Compra?.estatusCompra?.idEstatusCompra === EstatusCompra.APROBADO_CLIENTE && !row?.DscEstatus) &&
                                                    <FEnviarExtra
                                                        Compra={row?.Compra}
                                                        Moneda={row?.Meta?.Paquete?.MonedaProveedor}
                                                        disabled={(row?.Compra?.estatusCompra?.idEstatusCompra !== EstatusCompra.APROBADO_CLIENTE) ? true : false}
                                                    />
                                                }
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registros}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TExtrasContratados